import * as smartTransferApi from '@/network/api/smartTransfers.api.js'

/** Get SmartTransfers Request Received List
@return { promise }
*/
export const getSmartTransfersRequestsReceivedList = async (context, payload) => {
    const res = await smartTransferApi.getSmartTransfersRequestsReceivedList(payload)

    if (res) context.commit('SAVE_TRANSFERS_REQUEST_RECEIVED', { pageNumber: payload.params.pageNumber, data: res.data.data })

    return res
}

/** Get SmartTransfers Request Status List
@return { promise }
*/
export const getSmartTransfersRequestsStatusList = async (context, payload) => {
    const res = await smartTransferApi.getSmartTransfersRequestsStatusList()

    if (res) context.commit('SAVE_TRANSFERS_REQUEST_STATUS', res.data.data)

    return res
}

 /** Delete SmartTransfer Received Requests
@return {promise}
  */
export const rejectSmartTransferReceivedRequest = async (context, payload) => {
    const res = await smartTransferApi.rejectSmartTransferReceivedRequest(payload)

    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
